import { Injectable } from '@angular/core';
type Value = {
    [key:string | number]: string
}
type CacheObject = {
    r: Value,
    l: Value,
};
export type Side = 'r' | 'l';

class ColorCache {
    static cache:Value = {};
    static set(id:string, color:string) {
        this.cache[id] = color;
    }

    static get(id: string):string  {
        return this.cache[id];
    }
}

@Injectable({
    providedIn: 'root'
})
export class ColorFactory {
    claimId:string | undefined;
    taskId:string | undefined;
    cache: CacheObject | null | undefined;
    constructor(){
       
    }
    init(claimId:string,taskId:string):void {
        this.claimId = claimId;
        this.taskId = taskId;
        this.loadCache();
    }

    getCachingEngine(): Storage{
        return sessionStorage;
    }
    getColor(id: string, side: Side, index:number):string{
        let color;
         if(this.hasValidCache()){
            color = this.getColorsFromCache(id, side);
        }
        if(!color) {
            color = this.getGenericColor(id, index);
            if (id != '') {
                this.setCache(id, side, color);                
            }
        }
        return color;
    }
    setCache(index:string, side:Side, color:any){
        if(!this.cache) {
            this.loadCache();
        }
        if(!this.cache){
            this.cache = {
                r:{},
                l:{}
            }
        }
        this.cache[side][index] = color;
        this.commit();
    }
    commit():void{
        let identifier = this.getIdentifier();
        let cacheString = JSON.stringify(this.cache);
        let engine = this.getCachingEngine();
        engine.setItem(identifier, cacheString);
    }
    randomIntFromInterval(min: number, max: number): number { // min and max included 
        return Math.floor(Math.random() * (max - min + 1) + min)
    }
    getGenericColor(id:string, index:number):string{
        const listOfColors = [
        'rgb(54, 162, 235)',
        'rgb(255, 99, 132)',
        'rgb(75, 192, 192)',
        'rgb(255, 159, 64)',
        'rgb(153, 102, 255)',
        'rgb(255, 205, 86)',
        'rgb(201, 203, 207)'
       ];
       let cIndex = this.randomIntFromInterval(0,6);
       if(ColorCache.get(id)){
            return ColorCache.get(id);
       }
       if (id == '') {
        return listOfColors[cIndex];
       }
       ColorCache.set(id, listOfColors[cIndex]);
       return ColorCache.get(id);
    }
    rgba2hex(rgba:any, forceRemoveAlpha:boolean) {
        return "#" + rgba.replace(/^rgba?\(|\s+|\)$/g, '') // Get's rgba / rgb string values
        .split(',') // splits them at ","
        .filter((index:number) => !forceRemoveAlpha || index !== 3)
        .map((string:any) => parseFloat(string)) // Converts them to numbers
        .map((number:number, index:number) => index === 3 ? Math.round(number * 255) : number) // Converts alpha to 255 number
        .map((number:number) => number.toString(16)) // Converts numbers to hex
        .map((string:string) => string.length === 1 ? "0" + string : string) // Adds 0 when length of one number is 1
        .join("") // Puts the array to togehter to a string
      }
      
    getColorsFromCache(index: string, side: Side):string | null{
        let list = this.getListOfColorsBySide(side);
        if(Object.keys(list).length > 0){
            return list[index as keyof typeof list]|| null;
        }
        return null;
    }
    getListOfColorsBySide(side: Side): {} {
        if(this.cache){
            return this.cache[side];
        }
        return {};
    }
    hasValidCache():boolean{
        return this.cache !== null && this.cache !== undefined;
    }
    getIdentifier():string{
        return `palette.${this.claimId}.${this.taskId}`;
    }
    loadCache():void{
        let cache = this.retrieveCache();
        if(this.isValidCache(cache)){
            this.cache = cache;
        }
    }
    isValidCache(cache: CacheObject | null):boolean {
        if(!cache) {
            return false;
        }
        // Todo : validate the object have l & r property
        return Object.keys(cache).indexOf('l') != -1 && Object.keys(cache).indexOf('r') != -1
    }

    retrieveCache() : CacheObject | null{
        let engine = this.getCachingEngine();
        let identifier = this.getIdentifier();
        let cache = engine.getItem(identifier);
        if(cache){
            return JSON.parse(cache);
        }
       return null
    }
}